import { useCallback, useEffect, useRef, useState } from 'react';

const useEditionMode = ({ defaultComment, defaultLogType } = {}) => {
  const [comment, setComment] = useState(defaultComment ? defaultComment : '');
  const [logType, setLogType] = useState(defaultLogType ? defaultLogType : null);

  const handleTextareaChange = useCallback(
    (e, { value }) => {
      setComment(value);
    },
    [setComment]
  );

  const handleLogTypeChange = useCallback(
    (e, { value }) => {
      setLogType(value);
    },
    [setLogType]
  );

  const textareaElement = useRef(null);

  const textAreaRef = useCallback((ref) => {
    textareaElement.current = ref;
  }, []);

  useEffect(() => {
    !!textareaElement.current && textareaElement.current.focus();
  });

  return {
    comment,
    logType,
    handleTextareaChange,
    handleLogTypeChange,
    textAreaRef,
  };
};

export default useEditionMode;
